/**
 * Ce que le client a écrit dans `orders.notes` : ce qui précède la ligne « --- » sous
 * laquelle le système range ses traces datées (retrait, paiement rattrapé, montant à
 * vérifier). Copie de `api/src/common/notes-commande.ts` (`commentaireClient`) — les deux
 * bougent ensemble. Sans ce tri, le client lisait « [Retrait 20/10/2026 06:03:01] Remise
 * en caisse (vente SALE-…) » sous le titre « Commentaire » de sa commande.
 */
const MESSAGES_SYSTEME = [/^paiement retrouv[ée] chez stripe/i, /^montant stripe/i];
const LIGNE_TRACE = /^\[[^\]]*\d{1,2}\/\d{1,2}\/\d{2,4}[^\]]*\]/;

export function commentaireClient(notes: string | null | undefined): string | null {
  if (!notes) return null;
  const lignes = notes.split(/\r?\n/);
  const fin = lignes.findIndex((l) => l.trim() === '---');
  const texte = (fin >= 0 ? lignes.slice(0, fin) : lignes)
    .map((l) => l.trim())
    .filter((l) => l && !LIGNE_TRACE.test(l) && !MESSAGES_SYSTEME.some((re) => re.test(l)))
    .join('\n');
  return texte || null;
}
